import React from 'react';
import Styled from 'styled';
import classnames from 'classnames';
import { FormattedMessage } from 'react-intl';

import SVGIcon from 'lib/images/svg-pure-icon/svg-pure-icon';

import search from 'four-nets/icons/svg/icon_search.svg';

import defaultStyles from './search-input-with-button.scss';

export interface Props {
    styles: typeof defaultStyles;
    placeholder: string;
    value: string;
    submit: (e?: any) => any;
    onChange: (e: React.ChangeEvent<any>) => any;
    onBlur?: (e?: React.FocusEvent<any>) => any;
    onFocus?: (e?: React.FocusEvent<any>) => any;
}

export interface State {
    focused: boolean;
}

class SearchInputWithButton extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = { focused: false };
    }

    onInputFocus = (e: any) => {
        if (this.props.onFocus) {
            this.props.onFocus(e);
        }

        this.setState({ focused: true });
    };
    onInputBlur = (e: any) => {
        if (this.props.onBlur) {
            this.props.onBlur(e);
        }

        this.setState({ focused: false });
    };

    render() {
        const { styles, placeholder, onChange, value } = this.props;

        return (
            <div
                className={classnames(styles.searchInput, {
                    [styles.focused]: this.state.focused,
                })}
            >
                <FormattedMessage id='SEARCH_INPUT_PLACEHOLDER'>
                    {message => (
                        <>
                            <label htmlFor='search-input' className={styles.label}>
                                {message}
                            </label>

                            <input
                                name='search-input'
                                type='text'
                                placeholder={placeholder || (message as string)}
                                value={value}
                                onChange={onChange}
                                className={styles.input}
                                onFocus={this.onInputFocus}
                                onBlur={this.onInputBlur}
                            />
                        </>
                    )}
                </FormattedMessage>
                <button type='button' className={styles.buttonIcon} onClick={this.props.submit} aria-label='Submit'>
                    <SVGIcon src={search} className={styles.icon} />
                </button>
            </div>
        );
    }
}

export default Styled(defaultStyles)(SearchInputWithButton);
